// Entry point for the build script in your package.json
import "@hotwired/turbo-rails";
// import { Turbo } from "@hotwired/turbo-rails";
import "./consumer"; // Action Cable consumer
import "./controllers";
import "./nexus/app";
import "./nexus/pages/charts/apex-area";
import "./nexus/pages/charts/apex-bar";
import "./nexus/pages/charts/apex-column";
import "./nexus/pages/charts/apex-line";
import "./nexus/pages/charts/apex-pie";
import "./nexus/pages/dashboards/ecommerce";
import "./nexus/pages/dashboards/crm";
Turbo.session.drive = false;
